import { FlagsToggle } from 'flags'

export const PUBLISHED_CONTENT_FLAG =
  'feature_LEARN-28743-learn-curriculum-service-published-content'

export const isFlagOn = (flagSubcriptions = []) => {
  try {
    return FlagsToggle({
      flagSubcriptions,
      onCode: () => true,
      offCode: () => false,
    })()
  } catch {
    return false
  }
}
